import { em } from 'polished'
import styled, { css } from 'styled-components'

import { TextLH } from 'styles/components/typography'

export const Wrapper = styled.div`
  display: ${p => (p.isTextBottom ? 'block' : 'flex')};
`

export const TextWrapper = styled.div`
  padding-left: ${em(15)};
`

export const TextSnips = styled(TextLH)`
  color: ${p => p.theme.colors.white};
  display: block;
`
export const TextTest = styled(TextSnips)`
  font-family: ${p => p.theme.typography.mediumFont} !important;
`

export const BoxWrapper = styled.div`
  flex: 0 0 auto;
  width: ${em(100)};
  ${props =>
    props.isWgs &&
    css`
      margin-left: ${em(6.5)};
      margin-bottom: ${em(5.5)};
    `}

  ${p => p.theme.mq.upMd} {
    width: ${em(115)};
    ${props =>
      props.isWgs &&
      css`
        margin-left: ${em(7.475)};
        margin-bottom: ${em(6.325)};
      `}
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(123)};
    ${props =>
      props.isWgs &&
      css`
        margin-left: ${em(8)};
        margin-bottom: ${em(6.765)};
      `}
  }
`
